import { render, staticRenderFns } from "./ShareBubble.vue?vue&type=template&id=6f4900d9&lang=html"
import script from "./ShareBubble.vue?vue&type=script&lang=js"
export * from "./ShareBubble.vue?vue&type=script&lang=js"
import style0 from "./ShareBubble.vue?vue&type=style&index=0&id=6f4900d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports